module.exports = __webpack_public_path__ + "static/media/company-logo-6.ce983ace.png";